/**
 * Error codes shared by the library and the HTTP surface. The HTTP layer maps
 * these to statuses; it does not invent its own vocabulary.
 */

export type PricingErrorCode =
  | "VALIDATION_ERROR"
  | "INVALID_CURSOR"
  | "CURSOR_EXPIRED"
  | "NOT_FOUND"
  | "UNSUPPORTED_OPTION"
  | "IDEMPOTENCY_CONFLICT"
  | "SOURCE_BUSY"
  | "SOURCE_DISABLED"
  | "SOURCE_COOLING_DOWN"
  | "RATE_LIMITED"
  | "BODY_TOO_LARGE"
  | "UNAUTHORIZED"
  | "FORBIDDEN"
  | "STORE_UNAVAILABLE"
  | "INTERNAL_ERROR";

export interface ErrorDetail {
  readonly field: string;
  readonly issue: string;
}

export class PricingError extends Error {
  constructor(
    readonly code: PricingErrorCode,
    message: string,
    readonly details: readonly ErrorDetail[] = [],
    options?: { cause?: unknown },
  ) {
    super(message, options);
    this.name = "PricingError";
  }
}

export function validationError(message: string, details: readonly ErrorDetail[] = []): PricingError {
  return new PricingError("VALIDATION_ERROR", message, details);
}

export function notFound(message: string): PricingError {
  return new PricingError("NOT_FOUND", message);
}

export function unsupportedOption(message: string, details: readonly ErrorDetail[] = []): PricingError {
  return new PricingError("UNSUPPORTED_OPTION", message, details);
}
